export default class GeometrySelection {
  constructor() {}

  onGeometrySelected(layer, repository, updateLayerStyleFunc) {}
}
